import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as constructionsActions from '../../actions/constructions_actions';
import constants from '../../constants'

class ConstructionTypePopup extends React.Component {
  onCloseClick(e) {
    e.preventDefault();
    this.props.constructions_actions.hidePopup();
  }

  render() {
    let item = this.props.constructions_state.popup_content;
    return item ? (
      <div className={`popup-layer ${this.props.constructions_state.popup_shown ? 'active' : ''}`}>
        <div className='popup-wrapper'>
          <div className='base-width'>
            <div className='popup'>
              <div className='popup-header'>
                <a className='close' onClick={ this.onCloseClick.bind(this) } href='#'>Закрыть окно</a>
                <h2>{item.title}</h2>
              </div>
              <div className='popup-body'>
                <div className='door-info clearfix'>
                  <div dangerouslySetInnerHTML={{ __html: item.description }} />
                </div>
              </div>
              <div className='popup-footer'>
                <a className='close' onClick={ this.onCloseClick.bind(this) } href='#'>Закрыть окно</a>
              </div>
            </div>
          </div>
        </div>
        <div className='cover-all'></div>
      </div>
    ) : null;
  }
}

const mapStateToProps = (state) => {
  return {
    constructions_state: state.constructionsState,
    app: state.applicationState
  }
};

const mapDispatch = (dispatch) => {
  return {
    constructions_actions: bindActionCreators(constructionsActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch, null, {pure: false})(ConstructionTypePopup);




// WEBPACK FOOTER //
// ./app/javascript/app/components/construction_types/popup.jsx